import * as React from 'react';
import { Container, Modal, ModalProvider } from 'telia-front-react';
import { InternetDetailsModal } from '../details/InternetDetailsModal';
import { useInternetCalculator } from '../InternetCalculatorProvider';
import { DealerWithoutCustomerError } from '../notice/DealerWithoutCustomerError';
import { InternetSuggestSpeedCalculator } from '../suggest/InternetSuggestSpeedCalculator';
import InternetEditCarousel from './InternetEditCarousel';
import { useInternetEditOffers } from './InternetEditProvider';
const InternetEditContent = () => {
    const { internetOfferCards } = useInternetEditOffers();
    const { fetchInternetCalculatorConfig, modalState, setModalState } = useInternetCalculator();
    React.useEffect(() => {
        fetchInternetCalculatorConfig();
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Container, null,
            React.createElement(InternetSuggestSpeedCalculator, { isCollapsible: true, hidden: false, offerCards: internetOfferCards }),
            React.createElement(DealerWithoutCustomerError, { addressSelected: true })),
        React.createElement(InternetEditCarousel, null),
        React.createElement(ModalProvider, null,
            React.createElement(Modal, { size: "8-col", isOpen: !!(modalState === null || modalState === void 0 ? void 0 : modalState.offer), onClose: () => setModalState({ offer: null, showForm: false }) },
                React.createElement(InternetDetailsModal, null)))));
};
export default InternetEditContent;
